export const documentNumberFormatter = (documentNumber: string): string => {
  if (!documentNumber) return "";
  return documentNumber
    .replace(/\D+/g, "")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
};
